import { Component, OnInit } from '@angular/core';
import { ITenant } from '@internal-models/tenant.model';
import { TenantProvider } from '@internal-providers/tenant.provider';
import { NavigationType, UserPermissions } from '@shared-libs/enums';
import { NavigationService } from '@shared-services/navigation.service';

@Component({
	selector: 'home-desktop-page',
	templateUrl: 'home.desktop.page.html',
	styleUrls: ['./home.desktop.page.scss'],
})
export class HomeDesktopPage implements OnInit {
	public tenant: Pick<ITenant, 'name' | 'intro'>;
	public readonly UserPermissions: typeof UserPermissions = UserPermissions;

	constructor(
		private readonly tenantProvider: TenantProvider,
		private navigationService: NavigationService
	) {}

	public async ngOnInit(): Promise<void> {
		this.navigationService.onNavigateToCurrentPage().subscribe(async () => {
			this.tenant = await this.tenantProvider.getIntroDetails();
		});
	}

	public goToDigibankPage(): void {
		void this.navigationService.navigateTo(NavigationType.page, '/digibank');
	}
}
